import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertTemplateRequestsMutation, InsertTemplateRequestsMutationVariables } from '@/graphql/generated/graphql';
import { InsertTemplateRequestsDocument } from '@/graphql/generated/graphql';
export type TemplateRequestInsertInput = {
  OrganizationIds?: string[]
  RequesterEmail?: string
  RequesterName?: string
  Type?: string
  Status?: string
  Notes?: string
  AssignedTo?: string
  ResponseNotes?: string
  TemplateId?: string
  CompletedAt?: string
}

export type InsertTemplateRequestResponse = {
  data: {
    insertTemplateRequests: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertTemplateRequest = () => {
  const mutation = useMutation({
    mutationKey: ['insert-template-request'],
    mutationFn: (variables: TemplateRequestInsertInput) => {
      return graphqlClient.request<InsertTemplateRequestsMutation>(InsertTemplateRequestsDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertTemplateRequest: mutation.mutate,
    insertTemplateRequestAsync: mutation.mutateAsync,
  }
}

export const INSERT_TEMPLATE_REQUEST_MUTATION = InsertTemplateRequestsDocument;
